// ONE rule for blank lines between paragraphs in every outgoing email. Email clients (and Charlie's own preview CSS) disagree about the default margin on <p>, so each
// paragraph carries its spacing explicitly: margin:0 0 14px 0. Words are never touched. The server copy is api/_lib/paragraphSpacing.js (identical logic, tested to match).
const SPACING = 'margin:0 0 14px 0';

export function ensureParagraphSpacing(html) {
  let s = String(html == null ? '' : html);
  if (!/<p[\s>]/i.test(s)) return s;
  // a paragraph with no content and no style carries nothing to space
  s = s.replace(/<p>\s*<\/p>/gi, '');
  return s.replace(/<p(\s[^>]*)?>/gi, (whole, attrs) => {
    const a = attrs || '';
    const style = a.match(/\sstyle\s*=\s*("([^"]*)"|'([^']*)')/i);
    if (!style) return `<p${a} style="${SPACING}">`;
    const css = style[2] != null ? style[2] : style[3];
    if (/(^|;)\s*margin(-bottom)?\s*:/i.test(css)) return whole;      // already spaced by whoever wrote it
    const joined = css.trim() ? css.trim().replace(/;?$/, ';') + SPACING : SPACING;
    return `<p${a.replace(style[0], ` style="${joined}"`)}>`;
  });
}

// the gap before the signature: one explicit blank line, never stacked on top of an empty paragraph
export const SIGNATURE_GAP = '<br>';
